import { boot } from 'quasar/wrappers'
import { createI18n } from 'vue-i18n'
import messages from 'src/i18n'
import { LocalStorage } from 'quasar'

function getInitialLanguage() {
  const storedLang = LocalStorage.getItem('dreamdiner.locale')
  if (storedLang) {
    return storedLang
  }

  const browserLang = navigator.language || navigator.userLanguage

  const supportedLanguages = Object.keys(messages)

  if (supportedLanguages.includes(browserLang)) {
    return browserLang
  }

  const shortLang = browserLang.split('-')[0]
  const matchingLang = supportedLanguages.find(lang =>
    lang.startsWith(shortLang)
  )

  if (matchingLang) {
    return matchingLang
  }

  return 'en-US'
}

const lang = getInitialLanguage()

const i18n = createI18n({
  locale: lang,
  legacy: false,
  fallbackLocale: 'en-US',
  messages
})

export default boot(({ app }) => {
  app.use(i18n)
})

export { i18n }
